export default "__VITE_ASSET__CeOmV1JR__"